import React from 'react'
import classNames from 'classnames'

export default function Tabs({
    list,
    activeTab,
}) {

    return (
        <div>
            <ul className="flex items-center gap-1 bg-extralightprimary rounded-xl p-1 md:p-2">
                {list?.map((item, index) => {

                    const TabClasses = classNames({
                        "relative block cursor-pointer items-center rounded-lg py-2 px-3 text-sm": true,
                        "bg-dark text-white": activeTab === index,
                        "hover:bg-white": activeTab !== index,
                    })

                    return (
                        <li key={`${item.label}-${index}`}>
                            {item.onClick &&
                                <div onClick={() => item.onClick(index)} className={TabClasses}>{item.label}</div>
                            }
                            {item.href &&
                                <a href={item.href} className={TabClasses}>{item.label}</a>
                            }
                        </li>
                    )
                })}
            </ul>
        </div>
    )
}
